<template>
    <v-dialog v-model="visible" persistent :max-width="width || 640">
        <v-card>
            <v-card-title class="headline">{{ title }}</v-card-title>
            <v-card-text>
                <v-form ref="form" v-model="valid">
                    <p v-if="message">{{ message }}</p>
                    <p>{{ question }}</p>
                    <v-textarea v-if="!!showReason"
                                :label="reasonLabel"
                                v-model="reason"
                                :rules="[rules.required]"
                                required
                                rows="5"></v-textarea>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="Cancel" text>No</v-btn>
                <v-btn @click.native="Submit"
                       :loading="submitted"
                       :disabled="submitted"
                       :color="submitted ? '' : buttonColor"
                       :dark="!submitted">Yes</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import { eventBus } from '@/main'
    import rulesMixin from '@/views/components/mixins/base/rules.js'

    export default {
        props: ['instance', 'title', 'message', 'question', 'width', 'showReason', 'reasonLabel', 'buttonColor'],
        mixins: [rulesMixin],
        data() {
            return {
                visible: false,
                item: null,
                reason: '',
                valid: true,
                submitted: false,
            }
        },
        created() {
            eventBus.$off(`confirm-dialog:${this.instance}:show`).$on(`confirm-dialog:${this.instance}:show`, item => this.Confirm(item));
            eventBus.$off(`confirm-dialog:${this.instance}:cancel`).$on(`confirm-dialog:${this.instance}:cancel`, () => this.Cancel());
        },
        methods: {
            Confirm(item) {
                this.item = item;
                this.visible = true;
                this.submitted = false;
            },
            Cancel() {
                this.submitted = false;
                this.visible = false;
            },
            Submit() {
                if (this.$refs.form.validate()) {
                    this.submitted = true;
                    eventBus.$emit(`confirm-dialog:${this.instance}:ok`, this.item, this.reason);
                    this.visible = false;
                }
            },
        },
    }
</script>
